export default (that) => [
  {
    text: that.$l('menu_label_sapmle_detail') || '选品详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_label_sapmle_edit') || '编辑选品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    show: ({ tskStatus }) => {
      return (
        (!tskStatus || tskStatus === 'A') &&
        that.expoMeetingStatus != 'E' &&
        that.expoMeetingStatus != 'D'
      )
    },
  },
  {
    text: that.$l('menu_label_delete_sample') || '删除选品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    show: ({ tskStatus }) => {
      return (
        (!tskStatus || tskStatus === 'A') &&
        that.expoMeetingStatus != 'E' &&
        that.expoMeetingStatus != 'D'
      )
    },
  },
  {
    text: that.$l('menu_label_binding_samples') || '绑定样品',
    icon: 'el-icon-connection',
    menuType: 'binding',
    allow: 'B',
    show: ({ isTempImage, tskStatus }) => {
      return (
        (!tskStatus || tskStatus === 'A') &&
        isTempImage == 'Y' &&
        that.expoMeetingStatus != 'E' &&
        that.expoMeetingStatus != 'D'
      )
    },
  },
  {
    text: that.$l('menu_label_task_arrangement') || '任务安排',
    icon: 'el-icon-folder-checked',
    menuType: 'arrange',
    divided: true,
    show: ({ tskStatus, isTempImage, bindSample }) => {
      return (
        (isTempImage === 'Y' ? bindSample : true) &&
        (!tskStatus || tskStatus === 'A') &&
        that.expoMeetingStatus != 'E' &&
        that.expoMeetingStatus != 'D'
      )
    },
  },
]
